// Single axios instance with cookie credentials. Frontend calls this; backend reads cookies.
import axios from "axios";

const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL,
    withCredentials: true,
});

let refreshing = null;

api.interceptors.response.use(
    (r) => r,
    async (err) => {
        const original = err.config;
        // Retry once after refresh on 401
        if (err.response?.status === 401 && !original._retry && original.url !== "/auth/refresh" && original.url !== "/auth/login") {
            original._retry = true;
            try {
                refreshing = refreshing || api.post("/auth/refresh");
                await refreshing;
                refreshing = null;
                return api(original);
            } catch {
                refreshing = null;
            }
        }
        return Promise.reject(err);
    }
);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const formatGBP = (n) =>
    new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(n || 0);

export const formatGBPPrecise = (n) =>
    new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

export const formatNumber = (n) => new Intl.NumberFormat("en-GB").format(n || 0);

export const formatDate = (iso) => {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    } catch {
        return iso;
    }
};
